import React, { useEffect, useState } from "react";
import AddUpdateNationSitesModal from "./AddUpdateNationSites";
import { FaEdit } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import PageHeader from "../../components/molecules/PageHeader";
import userPermission from "../../util/userPermission";
import MUIDataTable from "../../components/molecules/DataTable/muigrid";
import { PiFileZipBold } from "react-icons/pi";
import api from "../../services/api";
import {
  get_nation_site,
  nationSiteReset,
} from "../../features/nationSitesSlice";
import { get_industry } from "../../features/IndustrySlice";
import AddPhoneModal from "./AddPhoneModal";
import AssignZipToDomain from "./Vendors/AssignZipToDomain";
const NationSites = () => {
  const dispatch = useDispatch();
  const { isLoading, nationSites } = useSelector((state) => state?.nation);
  const industry = useSelector((state) => state?.industry);
  const [isEditing, setIsEditing] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [isPhoneModal, setIsPhoneModal] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [assignZip, setAssignZip] = useState({
    showModal: false,
    site_id: null,
    recordData: null,
  });
  const cancelFormHandler = () => {
    setEditingRecord(null);
    setIsEditing(false);
    setIsPhoneModal(false);
  };
  const onPageSubmit = () => {
    setIsPhoneModal(false);
    dispatch(get_nation_site());
  };
  const openFormHandler = (record) => () => {
    setEditingRecord(record);
    setIsEditing(true);
  };
  useEffect(() => {
    dispatch(get_nation_site());
    dispatch(get_industry({ data: { page: 1, size: 100 } }));
    return () => {
      dispatch(nationSiteReset());
    };
    // eslint-disable-next-line
  }, []);
  const sites = nationSites?.records?.filter((e) => {
    return Object.keys(e)?.some(
      (key) =>
        e[key] &&
        e[key]?.toString()?.toLowerCase()?.includes(searchText?.toLowerCase())
    );
  });

  const handleOpenTab = (domain) => {
    const url = new URL("/domain_center/domains", window.location.origin);
    url.searchParams.append("domain", domain);
    const tabName = `domainCenterTab`;
    let existingTab = window.open("", tabName);
    if (!existingTab || existingTab.closed) {
      existingTab = window.open(url, tabName);
    } else {
      existingTab.location.href = url;
      existingTab.focus();
    }
  };
  const columnDefs = [
    { headerName: "#", field: "counter", filterable: false },
    {
      headerName: "Domain",
      field: "domain",
      flex: 1,
      renderCell: (params) => {
        return (
          <div className="flex flex-col">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://${params?.row["domain"]}`}
              className="text-black no-underline hover:underline cursor-poi"
            >
              {params?.value}
            </a>
          </div>
        );
      },
    },
    { headerName: "Industry", field: "industry_id", flex: 1 },
    {
      headerName: "Phone Count",
      field: "totalPhone",
      flex: 1,
      renderCell: (params) => {
        return params?.row?.totalPhone ? (
          <span
            onClick={() => handleOpenTab(params?.row?.domain)}
            className="text-blue-600 cursor-pointer hover:underline"
          >
            {params.row.totalPhone}
          </span>
        ) : (
          "N/A"
        );
      },
    },
    { headerName: "Rabbit MQ", field: "rabbit_mq_name", flex: 1 },
    {
      field: "actions",
      renderCell: (params) => (
        <div className="flex flex-row">
          {userPermission("Update National Site") ? (
            <>
              <PiFileZipBold
                size="20"
                title="Assign Zip To Domain"
                className="mr-1 cursor-pointer"
                onClick={() => openZipFormHandler(params.row.records?._id)}
              />
              <FaEdit
                onClick={openFormHandler(params.row.records)}
                className="my_navIcon"
                title="Update National Sites"
              />
            </>
          ) : null}
        </div>
      ),
      width: 100,
      filterable: false,
    },
  ];

  const getZips = async (site_id) => {
    setIsLoader(true);
    try {
      const res = await api.get(`/api/nation/national_site_zip/${site_id}`);
      if (res.status === 200 || res.status === 201) {
        setAssignZip((prev) => ({
          ...prev,
          recordData: res?.data,
        }));
      } else {
        console.log("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
    setIsLoader(false);
  };

  const openZipFormHandler = async (site_id) => {
    await getZips(site_id);
    setAssignZip((prev) => ({
      ...prev,
      showModal: true,
      site_id: site_id,
      recordData: prev.recordData,
    }));
  };

  const closeZipModalHandler = () => {
    setAssignZip({
      showModal: false,
      site_id: null,
      recordData: null,
    });
  };

  return (
    <>
      {isEditing && (
        <AddUpdateNationSitesModal
          editingRecord={editingRecord}
          modalTitle="Add National Site"
          onCancelForm={cancelFormHandler}
        />
      )}
      {assignZip?.showModal ? (
        <AssignZipToDomain
          editingRecord={assignZip?.recordData}
          site_id={assignZip?.site_id}
          modalTitle="Assign Zip"
          onCancelForm={closeZipModalHandler}
        />
      ) : null}
      {isPhoneModal ? (
        <AddPhoneModal
          modalTitle="Add Phone Number"
          onCancelForm={cancelFormHandler}
          onPageSubmit={onPageSubmit}
          data={nationSites}
        />
      ) : null}
      <PageHeader
        heading="National Site Listing"
        onClick={openFormHandler(0)}
        isAllowed={userPermission("Add National Site")}
        extraButton
        additionalBtnAllow
        extraButtonClick={() => setIsPhoneModal(true)}
        additionalBtnTitle="Add Phone Number"
      />

      <div className="bg-white my-3 border rounded">
        <MUIDataTable
          columnDefs={columnDefs}
          items={sites?.map((record, index) => {
            let counter = index + 1;
            const { domain, industry_id, totalPhone, rabbit_mq_name } = record;

            return {
              counter,
              records: { ...record },
              domain,
              rabbit_mq_name,
              totalPhone: totalPhone || "",
              industry_id: industry?.record?.records?.find(
                ({ _id }) => _id === industry_id
              )?.name,
            };
          })}
          totalItems={nationSites?.totalItems}
          searchText={searchText}
          setSearchText={setSearchText}
          pagination="No"
          isLoading={isLoading || isLoader}
        />
      </div>
    </>
  );
};

export default NationSites;
